import { createBrowserRouter, Navigate } from "react-router-dom";
import { AdminShell } from "./layout/AdminShell.js";
import { LoginPage } from "./pages/LoginPage.js";
import { DashboardPage } from "./pages/DashboardPage.js";
import { TenantListPage } from "./pages/TenantListPage.js";
import { TenantCreatePage } from "./pages/TenantCreatePage.js";
import { TenantDetailPage } from "./pages/TenantDetailPage.js";
import { BillingOrdersPage } from "./pages/BillingOrdersPage.js";
import { BillingSettingsPage } from "./pages/BillingSettingsPage.js";
import { PublicCollectProxyPoolPage } from "./pages/PublicCollectProxyPoolPage.js";
import { RuleBundlePage } from "./pages/RuleBundlePage.js";
import { DesktopUpdatesPage } from "./pages/DesktopUpdatesPage.js";
import { AuditPage } from "./pages/AuditPage.js";
import { RequireAdminAuth } from "./auth/RequireAdminAuth.js";

export const router = createBrowserRouter([
  {
    path: "/login",
    element: <LoginPage />
  },
  {
    path: "/",
    element: (
      <RequireAdminAuth>
        <AdminShell />
      </RequireAdminAuth>
    ),
    children: [
      { index: true, element: <DashboardPage /> },
      { path: "tenants", element: <TenantListPage /> },
      { path: "tenants/new", element: <TenantCreatePage /> },
      { path: "tenants/:tenantId", element: <TenantDetailPage /> },
      { path: "billing/orders", element: <BillingOrdersPage /> },
      { path: "billing/settings", element: <BillingSettingsPage /> },
      { path: "system/public-collect-proxy", element: <PublicCollectProxyPoolPage /> },
      { path: "rule-bundles", element: <RuleBundlePage /> },
      { path: "desktop-updates", element: <DesktopUpdatesPage /> },
      { path: "audit", element: <AuditPage /> }
    ]
  },
  { path: "*", element: <Navigate to="/" replace /> }
]);
